export default "__VITE_ASSET__BHpprGEK__"